import * as React from 'react';

var _style, _path, _path2, _path3, _mask, _path4, _path5, _mask2, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgDaily = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "13.5 18 17 14.5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a_7SZ5NB2K{fill:currentColor}.b_7SZ5NB2K{stroke:currentColor}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h44v44H0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "b_7SZ5NB2K",
  d: "M13.5 17.351c0-.286.228-.51.5-.51h16c.272 0 .5.224.5.51v13.123c0 .286-.228.51-.5.51H14a.505.505 0 0 1-.5-.51V17.35Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "b_7SZ5NB2K c_7SZ5NB2K",
  d: "M13.5 17.688c0-.555.36-.846.625-.846h15.75c.265 0 .625.29.625.846v2.192h-17v-2.192Z"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  className: "a_7SZ5NB2K",
  id: "path-3-inside-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 2.331c0-.535-.21-1.049-.586-1.427a1.99 1.99 0 0 0-2.828 0A2.029 2.029 0 0 0 2 2.33h1c0-.267.105-.524.293-.713a.995.995 0 0 1 1.414 0c.188.189.293.446.293.713h1Z"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  transform: "translate(13 13)",
  d: "M6 2.331c0-.535-.21-1.049-.586-1.427a1.99 1.99 0 0 0-2.828 0A2.029 2.029 0 0 0 2 2.33h1c0-.267.105-.524.293-.713a.995.995 0 0 1 1.414 0c.188.189.293.446.293.713h1Z",
  strokeWidth: 2,
  mask: "url(#path-3-inside-1)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  strokeWidth: 0.5,
  d: "M15.25 15.582h.5v1.519h-.5zM18.25 15.582h.5v1.519h-.5z"
})), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-6-inside-2",
  className: "a_7SZ5NB2K"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 2.331c0-.535-.21-1.049-.586-1.427a1.99 1.99 0 0 0-2.828 0A2.028 2.028 0 0 0 12 2.33h1c0-.267.105-.524.293-.713a.995.995 0 0 1 1.414 0c.188.189.293.446.293.713h1Z"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  transform: "translate(13 13)",
  d: "M16 2.331c0-.535-.21-1.049-.586-1.427a1.99 1.99 0 0 0-2.828 0A2.028 2.028 0 0 0 12 2.33h1c0-.267.105-.524.293-.713a.995.995 0 0 1 1.414 0c.188.189.293.446.293.713h1Z",
  strokeWidth: 2,
  mask: "url(#path-6-inside-2)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  strokeWidth: 0.5,
  d: "M25.25 15.582h.5v1.519h-.5zM28.25 15.582h.5v1.519h-.5z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.354 22.04a.508.508 0 0 1 0 .714l-6 6.057a.497.497 0 0 1-.754-.054l-2.6-3.5-2.6 3.5a.497.497 0 0 1-.7.1.508.508 0 0 1-.1-.706l3-4.038a.498.498 0 0 1 .8 0l2.654 3.572 5.593-5.645a.497.497 0 0 1 .707 0Z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  className: "a_7SZ5NB2K b_7SZ5NB2K",
  d: "m25 22.398 4-1.01-1 4.038-3-3.028Z"
})));

export { SvgDaily as default };
